module.exports = __webpack_public_path__ + "img/noGuide_c.50addab0.svg";